module.exports = {"542232100":"错那镇","542232200":"勒门巴民族乡","542232201":"贡日门巴民族乡","542232202":"吉巴门巴民族乡","542232203":"麻玛门巴民族乡","542232204":"库局乡","542232205":"曲卓木乡","542232206":"浪坡乡","542232207":"觉拉乡","542232208":"卡达乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/542232.json
// module id = 2756
// module chunks = 0